import { Injectable, Signal, computed, inject, signal } from "@angular/core";
import { UtilityService } from '@eforall/common';
import { DialogService } from '@eforall/dashboard';
import { ExplorableNavItem } from "@interfaces";
import { FuncService } from '../services/func/func.service.gen';
import { ExplorerNavigator } from './explorer-navigator';
import { ExplorerDialog } from './explorer.dialog';


@Injectable({ providedIn: 'root' })
export class ExplorerService {


	readonly #func = inject(FuncService);
	readonly #util = inject(UtilityService);
	readonly #dialogService = inject(DialogService);

	readonly nav = new ExplorerNavigator();
	#dialogBodyHeight: Signal<number> = signal(725); // default body height - 725, as default dialog height is 800

	get func() {
		return this.#func.explorer;
	}

	async show(explorableItem: ExplorableNavItem | undefined = undefined) {
		if (explorableItem) this.nav.go(explorableItem);
		const action = await this.#dialogService.showCustom(ExplorerDialog, {}, 1200, 800);
	}

	setDialogBodyHeight(dimensions: Signal<number>) {
		this.#dialogBodyHeight = dimensions;
	}
	readonly customGridHeight = computed(() => {
		const dialogHeight = this.#dialogBodyHeight();

		return dialogHeight - 70; // subtracting 70px for tabstrip header and padding
	});

}